import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers/index";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "Case",
  storage,
  blacklist: ["bookmarkFilter"]
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer
});

const persistedStore = persistStore(store);

export { store, persistedStore };
